/* eslint-disable import/no-anonymous-default-export */

/**
 * AXI code lists. Each holds the codes in the order the webservice returns
 * them (sorted by code) plus a code -> label map for labelling a record in an
 * overview without searching the list.
 */
const emptyLookup = () => ({ list: [], byCode: {} });

export default {
  lookups: {
    // drvotyp: DEVOTCE / DEVOTOM
    voedertypes: emptyLookup(),
    // drgenet: DEGENCE / DEGENOM
    genetica: emptyLookup(),
    // drcastr: DECASCE / DECASOM
    castratie: emptyLookup(),
    error: null,
    fetching: true,
  },
};
